import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';

import { accessTimePeriodForSports, isFinishedSportMatch } from '../../betting/accessMatchDetails';
import { IceHockeyPeriodType, RecordOfMatchEntity } from '../../betting/betting-entities';
import { SportId } from '../../betting/constants';
import { getMatchPeriodTitle } from '../../matchPeriods';
import { getFinishedPeriod } from '../get-finished-period';
import { IceHockeyKeyPeriod } from './constants';

import dictionary from './IceHockey.dictionary.json';

const THIRD_PERIOD = 3;

export const IceHockeyPeriods = (
  sportId?: SportId,
  periods?: RecordOfMatchEntity['periods'],
) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isResults = pathname.includes('results');

  if (isResults || isFinishedSportMatch(sportId, periods)) {
    return getFinishedPeriod(IceHockeyKeyPeriod.FINISHED, t);
  }

  const breakPeriod = periods?.get(IceHockeyPeriodType.BREAK, null);
  const isTimeBreak = !!breakPeriod && !breakPeriod.finished;

  if (isTimeBreak && typeof breakPeriod?.number === 'number' && breakPeriod.number !== THIRD_PERIOD) {
    return {
      key: IceHockeyKeyPeriod.TIME_BREAK_PERIOD,
      value: t(dictionary.timeBreakPeriod, { breakPeriodNumber: breakPeriod.number }),
    };
  }

  if (isTimeBreak && breakPeriod?.number === THIRD_PERIOD) {
    return {
      key: IceHockeyKeyPeriod.TIME_BREAK,
      value: t(dictionary.timeBreak),
    };
  }

  const timeoutPeriod = periods?.get(IceHockeyPeriodType.TIMEOUT, null);

  if (!!timeoutPeriod && !timeoutPeriod.finished) {
    return {
      key: IceHockeyKeyPeriod.TIMEOUT,
      value: getMatchPeriodTitle(IceHockeyPeriodType.TIMEOUT),
    };
  }

  const overtimePeriod = periods?.get(IceHockeyPeriodType.OVERTIME, null);

  if (typeof overtimePeriod?.number === 'number') {
    return {
      key: IceHockeyKeyPeriod.OVERTIME,
      value: t(dictionary.overtime, { overtime: overtimePeriod.number }),
    };
  }

  const bulletPeriod = periods?.get(IceHockeyPeriodType.BULLET, null);

  if (bulletPeriod !== null) {
    return {
      key: IceHockeyKeyPeriod.BULLET,
      value: t(dictionary.bullet),
    };
  }

  const timePeriod = accessTimePeriodForSports(sportId, periods) || 0;
  const period = timePeriod !== null ? t(dictionary.period, { period: timePeriod }) : null;

  return {
    key: IceHockeyKeyPeriod.PERIOD,
    value: {
      period,
    },
  };
};
